export default __webpack_public_path__ + "static/media/perla.6b33c1d8.jpg";